import moment from 'moment'

/**
 * Common date formatting utilities for analytics charts
 * Ensures consistent date handling across all components
 */

export interface DateFilters {
  start_date: Date | string
  end_date: Date | string
}

/**
 * Formats a date for URL parameters using local timezone
 * Avoids day shifts caused by UTC conversion
 */
export const formatDateForUrl = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Formats a date for API calls using UTC timezone
 * Ensures consistent API date formatting across all components
 */
export const formatDateForApi = (date: Date | string): string => {
  return moment(date).utcOffset(0).format('YYYY-MM-DD')
}

/**
 * Formats date filters for API calls
 * Returns an object with properly formatted start_date and end_date
 */
export const formatDateFiltersForApi = (filters: DateFilters) => {
  return {
    start_date: formatDateForApi(filters.start_date),
    end_date: formatDateForApi(filters.end_date),
  }
}

/**
 * Parses URL date parameters and returns Date objects
 * Handles both string and Date inputs
 */
export const parseUrlDateParams = (startDate: string, endDate: string) => {
  return {
    start_date: new Date(startDate),
    end_date: new Date(endDate),
  }
}
